import { uiText } from '../../i18n';
import { Seg } from '../../ui/Seg';
import { StudioHeaderContent } from './StudioHeaderContent';
import { priceText, record } from './studio-content';
import '../photo/native-photo-layout.css';
/** Цена за единицу («30 C за фото», «12 C за секунду»). total — цена шаблона за запуск («60 C»): единица не дописывается. */
export function StudioUnitPrice({ kind, price, total = false }: { kind: 'photo' | 'video'; price: unknown; total?: boolean }) {
  const fields = record(price);
  const amount = typeof price === 'number' ? price : (fields.amount ?? fields.circle);
  const formatted = priceText(amount);
  return formatted ? (
    <>
      <span className="mono">{formatted.replace(/\s*C$/, '')}</span> {uiText(total ? 'C' : kind === 'photo' ? 'C за фото' : 'C за секунду')}
    </>
  ) : null;
}

/** Общая T2/T1-шапка Фото/Видео из шаблона; API-режимы сопоставляет экран. */
export function StudioMediaHeader({
  kind,
  title,
  price,
  mode,
  onMode,
  locked,
  fileAvailable,
  textAvailable,
  enabled = true,
  showModes = true,
  unit,
  total,
}: {
  kind: 'photo' | 'video';
  title: string;
  price: unknown;
  mode: 'file' | 'text';
  onMode(mode: 'file' | 'text'): void;
  locked: boolean;
  fileAvailable: boolean;
  textAvailable: boolean;
  enabled?: boolean;
  showModes?: boolean;
  /** Цена за единицу подзаголовком; по умолчанию — у «Фото», у «Видео» по описанию и без сегмента. Бейдж в рамке — unit: false */
  unit?: boolean;
  /** Цена — за запуск шаблона, а не за единицу (StudioUnitPrice total) */
  total?: boolean;
}) {
  return (
    <StudioHeaderContent enabled={enabled}>
      <div className="studio-photo-header">
        <div className="photo-header-title bc-tt">
          <h2 className="pf-title">{uiText(title)}</h2>
          {(unit ?? (kind === 'photo' || mode === 'text' || !showModes)) && (
            <small className="bc-unit">
              <StudioUnitPrice kind={kind} price={price} total={total} />
            </small>
          )}
        </div>
        {showModes && (
          <Seg
            label={uiText(kind === 'photo' ? 'Режим фото' : 'Режим видео')}
            role="group"
            aria="aria-pressed"
            className="sm photo-header-modes"
            value={mode}
            items={[
              { key: 'file', label: uiText(kind === 'photo' ? 'Из фото' : 'Из файла'), disabled: locked || !fileAvailable },
              { key: 'text', label: uiText('По описанию'), disabled: locked || !textAvailable },
            ]}
            onChange={onMode}
          />
        )}
      </div>
    </StudioHeaderContent>
  );
}
